import React from 'react';
import Spinner from '@atlaskit/spinner';

import GoogleOneTap from '../../../components/GoogleOneTap';
import { useLoginState } from '../../../utilities/hooks/useLoginState';
import { loginPageId } from '../constants';
import { useLoginRecoveryOptionsContext } from '../contexts/LoginRecoveryOptionsContext';
import { useSocialLogin } from '../hooks/useSocialLogin';
import { useDynamicConfigs } from '../../../utilities/feature-flags/dynamic-config';
import { AidFrontendDynamicConfig } from '../../../providers/DynamicConfigs';
import { getBooleanDynamicConfigValueOrDefault } from '../../../providers/common';

export const LoginGoogleOneTapRenderBoundary = ({ children }: { children: React.ReactNode }) => {
  const dynamicConfigs = useDynamicConfigs();

  const { loginRecoveryOptions } = useLoginRecoveryOptionsContext();

  const { isGoogleOneTapDismissed } = useSocialLogin();

  const { state, isLoading: isPageStateLoading, error: pageStateError } = useLoginState();

  if (isPageStateLoading) {
    return <Spinner label="Login page loading" />;
  } else if (!state || pageStateError) {
    throw new Error(`Page state loading unsuccessful. \nPage state error: ${pageStateError}`);
  }

  const { googleAuthClientId } = state.appConfig;
  const { hashedCsrfToken } = state;

  const disableOneTap =
    isGoogleOneTapDismissed ||
    getBooleanDynamicConfigValueOrDefault(
      dynamicConfigs,
      AidFrontendDynamicConfig.GOOGLE_ONE_TAP_KILL_SWITCH
    );

  return (
    <GoogleOneTap
      csrfToken={hashedCsrfToken ?? 'token-should-be-loaded'}
      googleAuthClientId={googleAuthClientId}
      source={loginPageId}
      enabled={!disableOneTap}
      recoveryOptions={loginRecoveryOptions}>
      {children}
    </GoogleOneTap>
  );
};
